import { lazy } from 'react';

import { withLoader } from '@perpay-web/components/higher-order/WithLoader/WithLoader';
import { importPayrollPaymentSetupContainer } from '@perpay-web/fintech/utils/imports/importPayrollPaymentSetupContainer';

const LazyPayrollPaymentSetupContainer = withLoader(
    lazy(importPayrollPaymentSetupContainer),
);

export default LazyPayrollPaymentSetupContainer;
